import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen, Moon, RefreshCw, Baby, Heart, Users } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    icon: <BookOpen className="w-8 h-8 text-gold-400" data-id="element-270" />,
    title: 'TOMO 1 — La Ciencia del Sueño',
    desc: 'Por qué tu bebé duerme como duerme. Ciclos, melatonina, ventanas de vigilia y entorno óptimo. La base que nadie te explicó antes de la primera noche difícil.'
  }, {
    icon: <Moon className="w-8 h-8 text-gold-400" data-id="element-271" />,
    title: 'TOMO 2 — Acción y Rutinas SOS',
    desc: 'La rutina de 4 pasos que activa el sueño por anticipación. El Puente de Sueño para transferir sin despertar. El Plan de 14 Días noche por noche.'
  }, {
    icon: <RefreshCw className="w-8 h-8 text-gold-400" data-id="element-272" />,
    title: 'TOMO 3 — Crisis, Regresiones y Casos Especiales',
    desc: 'Regresiones de 4, 8, 12 y 18 meses. Dentición, enfermedades y viajes. El Plan de Emergencia para cuando nada funciona.'
  }, {
    icon: <Baby className="w-8 h-8 text-gold-400" data-id="element-273" />,
    title: 'TOMO 4 — El Sueño del Bebé Prematuro',
    desc: 'Protocolo específico con edad corregida. Transición de la UCIN al hogar. El único tomo del mercado diseñado exclusivamente para familias con bebés prematuros.'
  }, {
    icon: <Heart className="w-8 h-8 text-gold-400" data-id="element-274" />,
    title: 'TOMO 5 — Sueño y Desarrollo Emocional',
    desc: 'Miedos nocturnos, pesadillas y terrores. El rol del apego en el sueño. Por qué el estado emocional del día impacta directamente en la noche.'
  }, {
    icon: <Users className="w-8 h-8 text-gold-400" data-id="element-275" />,
    title: 'TOMO 6 — El Padre en el Proceso',
    desc: 'El manual que nadie escribió para el co-cuidador. Rol nocturno, agotamiento paterno, vínculo y cómo dividir las noches sin que sea una batalla.'
  }];
  const includes = ['Protocolos listos para aplicar esta noche', 'Checklists imprimibles de consulta rápida', 'Tablas de referencia por edad', 'Casos reales con soluciones concretas', '100% basado en evidencia científica'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-276">
      <div className="text-center mb-16" data-id="element-277">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-278">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-279">
            🏆 KIT SOS NOCTURNO — MUNDO RECURSOS™
          </h2>
          <p className="text-xl md:text-2xl text-gold-400 font-medium mb-6" data-id="element-280">
            6 Tomos + 6 Bonos — 0 a 24 meses
          </p>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto" data-id="element-281">
            Todo lo que necesitás para transformar las noches de tu familia
          </p>
        </motion.div>
      </div>

      <div className="mb-12 text-center" data-id="element-282">
        <h3 className="text-2xl font-bold text-white mb-8 border-b border-navy-700 pb-4 inline-block" data-id="element-283">
          LOS 6 TOMOS
        </h3>
      </div>

      <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mb-16" data-id="element-284">
        {tomos.map((tomo, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-navy-800/60 border border-navy-700 p-8 rounded-2xl hover:border-gold-500/50 transition-colors group" data-id="element-285">
            <div className="mb-4 p-3 bg-navy-900 rounded-xl inline-block group-hover:scale-110 transition-transform" data-id="element-286">
              {tomo.icon}
            </div>
            <h4 className="text-xl font-bold text-white mb-3" data-id="element-287">{tomo.title}</h4>
            <p className="text-blue-100/80 leading-relaxed" data-id="element-288">{tomo.desc}</p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-gradient-to-br from-navy-800 to-navy-900 border border-gold-500/30 rounded-3xl p-8 md:p-10 max-w-4xl mx-auto" data-id="element-289">
        <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-290">
          Cada tomo incluye:
        </h4>
        <div className="grid sm:grid-cols-2 gap-4" data-id="element-291">
          {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-292">
              <CheckCircle2 className="w-6 h-6 text-green-400 shrink-0" data-id="element-293" />
              <span className="text-blue-50" data-id="element-294">{item}</span>
            </div>)}
        </div>
      </motion.div>
    </section>;
}